
import Records from "../Records/Records";

const LatestRecords = () => {
    return (<Records recordsUrl='records/latest' />)
}

export default LatestRecords;